/* Generado por scripts/archive-curate.js — no editar a mano. Películas elegidas a mano de Internet Archive. */

export const ARCHIVE_FILMS = [
    {
        "id": "Night_Of_The_Living_Dead_raw_HD_WS",
        "title": "Night of the Living Dead",
        "year": 1968,
        "genre": "horror",
        "file": "NightOfTheLivingDeadWSInternationalPrint.mp4",
        "size": 817380054,
        "secs": 5742,
        "license": "http://creativecommons.org/publicdomain/mark/1.0/"
    },
    {
        "id": "Nosferatu_most_complete_version_93_mins.",
        "title": "Nosferatu",
        "year": 1922,
        "genre": "horror",
        "file": "Nosferatu_1922_Symphony_of_Horror_512kb.mp4",
        "size": 395416378,
        "secs": 5602,
        "license": ""
    },
    {
        "id": "DasKabinettdesDoktorCaligariTheCabinetofDrCaligari",
        "title": "The Cabinet of Dr. Caligari",
        "year": 1920,
        "genre": "horror",
        "file": "The_Cabinet_of_Dr._Caligari_512kb.mp4",
        "size": 222148532,
        "secs": 3061,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "ThePhantomoftheOpera",
        "title": "The Phantom of the Opera",
        "year": 1925,
        "genre": "horror",
        "file": "Phantom_of_the_Opera_512kb.mp4",
        "size": 463554725,
        "secs": 6389,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "CarnivalofSouls",
        "title": "Carnival of Souls",
        "year": 1962,
        "genre": "horror",
        "file": "CarnivalOfSouls.mp4",
        "size": 518506661,
        "secs": 4980,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "house_on_haunted_hill_ipod",
        "title": "House on Haunted Hill",
        "year": 1959,
        "genre": "horror",
        "file": "house_on_haunted_hill.mp4",
        "size": 843645455,
        "secs": 4483,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "The_Little_Shop_of_Horrors.mpeg",
        "title": "The Little Shop of Horrors",
        "year": 1960,
        "genre": "comedy",
        "file": "The_Little_Shop_of_Horrors.mp4",
        "size": 452745287,
        "secs": 4351,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "lost_world",
        "title": "The Lost World",
        "year": 1925,
        "genre": "scifi",
        "file": "lost_world.mp4",
        "size": 424986300,
        "secs": 4085,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "TheLastManOnEarth1964_201808",
        "title": "The Last Man on Earth",
        "year": 1964,
        "genre": "scifi",
        "file": "The Last Man on Earth (1964).mp4",
        "size": 541897119,
        "secs": 5204,
        "license": "http://creativecommons.org/publicdomain/mark/1.0/"
    },
    {
        "id": "ATripToTheMoonGeorgeMelies",
        "title": "A Trip to the Moon",
        "year": 1902,
        "genre": "scifi",
        "file": "A Trip to the Moon-George Méliès.mp4",
        "size": 218115276,
        "secs": 772,
        "license": ""
    },
    {
        "id": "plan-9-from-outer-space",
        "title": "Plan 9 from Outer Space",
        "year": 1959,
        "genre": "scifi",
        "file": "plan-9-from-outer-space.mp4",
        "size": 454359304,
        "secs": 4700,
        "license": "http://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "The_General_Buster_Keaton",
        "title": "The General",
        "year": 1926,
        "genre": "silent",
        "file": "The_General.mp4",
        "size": 412400222,
        "secs": 4724,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "sherlockjr1924_201909",
        "title": "Sherlock Jr.",
        "year": 1924,
        "genre": "silent",
        "file": "Sherlock Jr. - Buster Keaton (1924) HD [720p].mp4",
        "size": 354283591,
        "secs": 2674,
        "license": "http://creativecommons.org/publicdomain/mark/1.0/"
    },
    {
        "id": "safety-last-1923-silent-film-noir-comedy-short",
        "title": "Safety Last!",
        "year": 1923,
        "genre": "silent",
        "file": "Safety Last (1923 Silent, Film noir, Comedy, Short).mp4",
        "size": 43670648,
        "secs": 681,
        "license": "http://creativecommons.org/publicdomain/mark/1.0/"
    },
    {
        "id": "CollegeDays",
        "title": "The Freshman",
        "year": 1925,
        "genre": "silent",
        "file": "IMG_7817.mp4",
        "size": 474916836,
        "secs": 4576,
        "license": "http://creativecommons.org/publicdomain/mark/1.0/"
    },
    {
        "id": "the-gold-rush-film-1925",
        "title": "The Gold Rush",
        "year": 1925,
        "genre": "silent",
        "file": "The-Gold-Rush-1925.mp4",
        "size": 457641337,
        "secs": 5195,
        "license": "https://creativecommons.org/publicdomain/mark/1.0/"
    },
    {
        "id": "NanookOfTheNorth",
        "title": "Nanook of the North",
        "year": 1922,
        "genre": "silent",
        "file": "Nanook of the North.mp4",
        "size": 846486734,
        "secs": 4645,
        "license": ""
    },
    {
        "id": "MyMovie_201801",
        "title": "Our Hospitality",
        "year": 1923,
        "genre": "silent",
        "file": "My Movie.mp4",
        "size": 669557570,
        "secs": 4449,
        "license": ""
    },
    {
        "id": "mymovie_202004",
        "title": "The Navigator",
        "year": 1924,
        "genre": "silent",
        "file": "My Movie.mp4",
        "size": 1033301465,
        "secs": 3581,
        "license": ""
    },
    {
        "id": "silent-seven-chances",
        "title": "Seven Chances",
        "year": 1925,
        "genre": "silent",
        "file": "Seven Chances.mp4",
        "size": 296323835,
        "secs": 3429,
        "license": ""
    },
    {
        "id": "his_girl_friday",
        "title": "His Girl Friday",
        "year": 1940,
        "genre": "classic",
        "file": "his_girl_friday.mp4",
        "size": 575274912,
        "secs": 5505,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "meet_john_doe",
        "title": "Meet John Doe",
        "year": 1941,
        "genre": "classic",
        "file": "meet_john_doe.mp4",
        "size": 769066604,
        "secs": 7371,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "Detour",
        "title": "Detour",
        "year": 1945,
        "genre": "classic",
        "file": "Detour.mp4",
        "size": 423770341,
        "secs": 4058,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "TheStranger_0",
        "title": "The Stranger",
        "year": 1946,
        "genre": "classic",
        "file": "The_Stranger.mp4",
        "size": 570456474,
        "secs": 5473,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "mclintok_widescreen",
        "title": "McLintock!",
        "year": 1963,
        "genre": "classic",
        "file": "McLintock.mp4",
        "size": 1553674262,
        "secs": 7607,
        "license": "http://creativecommons.org/licenses/publicdomain/"
    },
    {
        "id": "charade-1963-cary-grant-audrey-hepburn-comedy-mystery-romance-thriller-full-movie",
        "title": "Charade",
        "year": 1963,
        "genre": "classic",
        "file": "Charade_READY.mp4",
        "size": 424901742,
        "secs": 6785,
        "license": "https://creativecommons.org/publicdomain/mark/1.0/"
    }
];
